"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
require("vue-slider-component/theme/default.css");
var _vue2Editor = require("vue2-editor");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _hike = require("@/api/hike");
var _resource = require("@/api/resource");
var _game = require("@/api/game");
var _vuex = require("vuex");
var _lhJsCommonLib = require("@lifehikes/lh-js-common-lib");
var _hike720Report = require("@/api/hike720-report");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Tinymce from '@/components/Tinymce'
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeStageActionSet',
  components: {
    VueEditor: _vue2Editor.VueEditor,
    UploadExcelComponent: _index.default
  },
  data() {
    return {
      customToolbar: [['bold'], [{
        list: 'bullet'
      }], ['link']],
      rateTooltipFormatter: '{value}%',
      asIndex: 0,
      actionIndex: 0,
      dialogSkillVisible: false,
      dialogResourceVisible: false,
      dialogGameVisible: false,
      resourceQuery: {
        page: 1,
        limit: 999,
        q: undefined,
        sort: 'title'
      },
      resourceOptions: [],
      skillList: [],
      gameList: [],
      loading: false,
      firstTab: 'stage1',
      actionsetTab: 'actionset1',
      actionTab: 'setting',
      activeName: 'first',
      stageActionSetType: _lifehikesInitData.stageActionSetType,
      stageActionType: _lifehikesInitData.stageActionType,
      stageIndex: 0,
      hike: {},
      relatedLoops: [],
      relatedLoopsLoading: false,
      emptyActionSet: {
        type: '',
        title: '',
        actions: [],
        dialTestRate: 20
      },
      emptyAction: {
        type: '',
        title: '',
        // no use
        description: '',
        isSubscriptionIndividualCoachingMandatoryActivity: false,
        enableDialTest: false,
        // default is false
        enableP2pDialTest: false,
        p2pDialTestRaterCount: 1,
        p2pDialTestRaterMin: 1,
        p2pDialTestRaterMax: 5,
        minRecordingTime: 30,
        // in seconds
        maxRecordingTime: 120,
        // in seconds
        autoCutRecordingTime: 150,
        // in seconds
        stepsValue: 0,
        // after the action, gain steps
        timeInMinutes: 0,
        // in minutes
        recordingTexts: [],
        // For prompts during recording.
        scoreConfig: undefined
      },
      defaultScore: {
        rate: 30,
        scores: (0, _lhJsCommonLib.tagMapping)(_lifehikesInitData.skillCompassVideoDefault)
      },
      suggestWeightForEachVideo: 100,
      survey720ParticipantList: [],
      survey720ParticipantWithoutSurveyList: [],
      survey720RateError: "",
      survey720DataType: "",
      survey720Status: {},
      survey720TableTotalDataCount: 0,
      survey720TableValidDataCount: 0,
      survey720ScoreMapping: {},
      survey720TableData: {},
      survey720TableHeader: [],
      survey720DialogVisible: false,
      survey720DialogType: "",
      survey720SmallDrop: "smallDrop",
      scLibrary: (0, _lhJsCommonLib.tagMapping)(_lifehikesInitData.skillCompassLibrary)
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(['email']),
    isHikeAssociatedWithSubscription() {
      if (Array.isArray(this.relatedLoops) && this.relatedLoops.length > 0) {
        return this.relatedLoops.some(loop => loop && loop.metadata && loop.metadata.subscriptionId);
      }
      return false;
    }
  },
  /*
  watch: {
    hikeStages: {
      handler(newVal) {
        // showDebugLog('Child-module emit to parent new value', newVal)
        this.passBackToParent(newVal)
      },
      deep: true
    }
  },
  */
  async created() {
    this.firstTab = typeof this.$route.query.s === 'undefined' ? 'stage1' : this.$route.query.s;
    await this.getHike();
    await this.getHikeSkillList();
    await this.getHikeGameList();
    this.getResources();
    this.getHikeGameList();
    this.getHikeParticipants();
    this.getSurvey720Status();
    this.getRelatedLoops();
  },
  methods: {
    dateFormatter(dateStr) {
      const theDate = (0, _momentTimezone.default)(String(dateStr));
      if (theDate.isValid()) {
        return theDate.format("YYYY-MM-DD HH:mm:ss");
      }
      return "--";
    },
    backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push(`/hike/edit/${id}`);
    },
    moveNext(stageIndex, actionsetIndex) {
      if (actionsetIndex < this.hike.stages[stageIndex].actionSets.length) {
        var element = this.hike.stages[stageIndex].actionSets[actionsetIndex];
        this.$set(this.hike.stages[stageIndex].actionSets, actionsetIndex, this.hike.stages[stageIndex].actionSets[actionsetIndex + 1]);
        this.$set(this.hike.stages[stageIndex].actionSets, actionsetIndex + 1, element);
        // console.log(this.hikeStages);
      }
    },
    resetScore(stageIdx, actionsetIdx, actionIdx) {
      let scoreConfig = this.hike.stages[stageIdx].actionSets[actionsetIdx].actions[actionIdx].scoreConfig;
      let oldConfig = _lodash.default.cloneDeep(scoreConfig);
      let newConfig = _lodash.default.cloneDeep(this.defaultScore);
      newConfig['scores'].forEach(item => {
        let oldValue = oldConfig['scores'].find(oldItem => oldItem['key'] === item['key']);
        if (oldValue) {
          item['rate'] = oldValue['rate'];
          item['weight'] = oldValue['rate'];
          item['enable'] = oldValue['enable'];
        }
      });
      this.hike.stages[stageIdx].actionSets[actionsetIdx].actions[actionIdx].scoreConfig = newConfig;
    },
    movePrevious(stageIndex, actionsetIndex) {
      if (actionsetIndex > 0) {
        var element = this.hike.stages[stageIndex].actionSets[actionsetIndex];
        this.$set(this.hike.stages[stageIndex].actionSets, actionsetIndex, this.hike.stages[stageIndex].actionSets[actionsetIndex - 1]);
        this.$set(this.hike.stages[stageIndex].actionSets, actionsetIndex - 1, element);
        // console.log(this.hikeStages);
      }
    },
    save() {
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      const stageActionSetTypes = {};
      stageActionSetTypes['stage'] = ['bunny', 'diamond', 'info', 'moment', 'bonus'];
      stageActionSetTypes['benchmark'] = ['bunny', 'diamond', 'moment', 'benchmark', 'benchmarkreport', 'bonus'];
      stageActionSetTypes['summit'] = ['summit', 'moment', 'summitreport'];
      const stages = this.hike.stages;
      for (const stageIndex in stages) {
        let benchmarkType = 0;
        let benchmarkReportType = 0;
        let summitType = 0;
        let summitReportType = 0;
        let componentType = 0;
        for (const actionSetIdnex in stages[stageIndex].actionSets) {
          if (stages[stageIndex].actionSets[actionSetIdnex].type === undefined || stages[stageIndex].actionSets[actionSetIdnex].type === '') {
            (0, _log.displayPopupMessage)('Type is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity.', 'error');
            return;
          }
          for (const actionIndex in stages[stageIndex].actionSets[actionSetIdnex].actions) {
            const actionType = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].type;
            if (actionType === undefined || actionType === '') {
              (0, _log.displayPopupMessage)('Type is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
              return;
            }
            if (actionType === "dialtestexercise") {
              componentType++;
            }
            const actionTitle = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].title;
            if (actionTitle === undefined || actionTitle === '') {
              (0, _log.displayPopupMessage)('Title is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
              return;
            }
            const enableP2pDialTest = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].enableP2pDialTest;
            if (enableP2pDialTest) {
              const p2pDialTestRaterMax = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].p2pDialTestRaterMax;
              const p2pDialTestRaterMin = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].p2pDialTestRaterMin;
              if (p2pDialTestRaterMax < p2pDialTestRaterMin) {
                (0, _log.displayPopupMessage)('P2P Dial Testing maximum value must be larger or equal than the minimum value in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease modify it before saving activity.', 'error');
                return;
              }
            }
            if (actionType === 'skill') {
              const skillId = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].skill;
              if (skillId === undefined || skillId === null || skillId === '') {
                (0, _log.displayPopupMessage)('Skill Id is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
                return;
              }
            }
            if (actionType === 'resource') {
              const resource = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].resource;
              if (resource === undefined || resource === null) {
                (0, _log.displayPopupMessage)('Resource Id is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
                return;
              }
            }
            if (actionType === 'game') {
              const game = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].game;
              if (game === undefined || game === null) {
                (0, _log.displayPopupMessage)('Game Id is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + '. \nPlease add it before saving activity.', 'error');
                return;
              }
            }
            let scoreConfig = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].scoreConfig;
            if (scoreConfig !== undefined && scoreConfig['scores'] !== undefined && Array.isArray(scoreConfig['scores'])) {
              scoreConfig['scores'].forEach(item => {
                if (item['rate'] !== undefined) {
                  item['weight'] = item['rate'];
                }
              });
            }
            const actionDescription = stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].description;
            if (actionDescription && actionDescription !== '') {
              const divForDescription = document.createElement('div');
              divForDescription.innerHTML = actionDescription;
              const links = divForDescription.getElementsByTagName('a');
              for (const link of links) {
                var hrefs = link.outerHTML.match(/href="([^"]*)/g);
                var href = hrefs[hrefs.length - 1].substring(6);
                if (!this.isValidHttpUrl(href)) {
                  (0, _log.displayPopupMessage)('Please check link ' + link.outerText + ' in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + ', Component ' + (1 * actionIndex + 1) + ' description.', 'error');
                  return;
                }
              }
            }
          }
          const actionSet = stages[stageIndex].actionSets[actionSetIdnex];
          const actionSetTypes = stageActionSetTypes[stages[stageIndex].type];
          const type = actionSet.type;
          if (type === 'benchmark') {
            let raterCount = actionSet.raterCount;
            let raterTaskCredit = actionSet.raterTaskCredit;
            if (raterTaskCredit === undefined) {
              (0, _log.displayPopupMessage)('Task Credit is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity.', 'error');
              return;
            }
            if (raterCount === undefined) {
              (0, _log.displayPopupMessage)('RaterCount is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity. (Suggest to set it as 1.)', 'error');
              return;
            }
            benchmarkType++;
          } else if (type === 'benchmarkreport') {
            benchmarkReportType++;
          } else if (type === 'summit') {
            let raterCount = actionSet.raterCount;
            let raterTaskCredit = actionSet.raterTaskCredit;
            if (raterTaskCredit === undefined) {
              (0, _log.displayPopupMessage)('Task Credit is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity.', 'error');
              return;
            }
            if (raterCount === undefined) {
              (0, _log.displayPopupMessage)('RaterCount is missing in Stage ' + (1 * stageIndex + 1) + ', Activity ' + (1 * actionSetIdnex + 1) + '. \nPlease add it before saving activity. (Suggest to set it as 2.)', 'error');
              return;
            }
            summitType++;
          } else if (type === 'summitreport') {
            summitReportType++;
          }
          if (!actionSetTypes.includes(actionSet.type)) {
            const msg = 'Stage ' + (1 * stageIndex + 1) + ':[' + stages[stageIndex].type + '] should not include activity: [' + actionSet.type + '].';
            (0, _log.displayPopupMessage)(msg, 'error');
            return;
          }
        }
        let errType = '';
        if (benchmarkType > 1) {
          errType = 'benchmark';
        } else if (benchmarkReportType > 1) {
          errType = 'benchmarkreport';
        } else if (summitType > 1) {
          errType = 'summit';
        } else if (summitReportType > 1) {
          errType = 'summitreport';
        }
        if (errType !== '') {
          (0, _log.displayPopupMessage)('Activity type [' + errType + '] should not more than 1. \nPlease remove it before saving activity.', 'error');
          return;
        }
        if (componentType > 1) {
          (0, _log.displayPopupMessage)("Within a stage, Component type 'dialtestexercise'  should not more than 1.\n It's in Stage " + (1 * stageIndex + 1) + ".\n Please remove it before saving activity.", 'error');
          return;
        }
      }
      this.loading = true;
      (0, _hike.updateHikeById)(token, id, {
        stages
      }).then(response => {
        this.hike = response.data;
        for (var i = 0; i < this.checkArrayLength(this.hike.stages); i++) {
          for (var j = 0; j < this.checkArrayLength(this.hike.stages[i].actionSets); j++) {
            for (var k = 0; k < this.checkArrayLength(this.hike.stages[i].actionSets[j].actions); k++) {
              if (this.hike.stages[i].actionSets[j].actions[k].type === 'resource') {
                var resId = this.hike.stages[i].actionSets[j].actions[k].resource ? this.hike.stages[i].actionSets[j].actions[k].resource.id : null;
                console.info('resource id:' + resId);
                this.hike.stages[i].actionSets[j].actions[k].resource = resId;
              }
            }
          }
        }
        this.loading = false;
        const msg = `${response.data.title} (${response.data.id}) is updated.`;
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(this, 'Hike', `${_lifehikesInitData.userEvent.hike.edit}`, oEmail, `Edit in Action Setting - Hike Id: ${id}`);
        (0, _ga.writeGaEvent)(this, 'Hike', `${_lifehikesInitData.userEvent.hike.edit}`, this.email, `avoid undefined email, Edit in Action Setting - Hike Id: ${id}`);
        var keys_to_keep = ['role', 'user'];
        const result = this.hike.staff.map(e => {
          const obj = {};
          keys_to_keep.forEach(k => obj[k] = e[k]);
          return obj;
        });
        (0, _ga.writeGaEvent)(this, 'Hike', `${_lifehikesInitData.userEvent.hike.edit}`, oEmail, `Staff: ${JSON.stringify(result)}`);
      }).catch(error => {
        (0, _log.showDebugLog)('hike-updateHikeById-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === 'http:' || url.protocol === 'https:';
    },
    async getHike() {
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      await (0, _hike.getHikeById)(token, id).then(response => {
        this.hike = response.data;
        let overallTotal = 0;
        if (this.hike.skillCompassDimensions === 'auto') {
          if (this.hike.report && this.hike.report.scoreConfig && this.hike.report.scoreConfig.overall) {
            for (const skill of this.hike.report.scoreConfig.overall) {
              overallTotal += skill.weight;
            }
          }
        }
        this.suggestWeightForEachVideo = 100 - overallTotal;
        //fixed bug LHVO-4485
        if (this.hike.report) {
          if (this.hike.report.scoreConfig) {
            this.defaultScore.scores = this.hike.report.scoreConfig.video;
          }
        }
        for (var i = 0; i < this.checkArrayLength(this.hike.stages); i++) {
          for (var j = 0; j < this.checkArrayLength(this.hike.stages[i].actionSets); j++) {
            for (var k = 0; k < this.checkArrayLength(this.hike.stages[i].actionSets[j].actions); k++) {
              if (this.hike.stages[i].actionSets[j].actions[k].isSubscriptionIndividualCoachingMandatoryActivity === undefined) {
                this.$set(this.hike.stages[i].actionSets[j].actions[k], 'isSubscriptionIndividualCoachingMandatoryActivity', false);
              }
              if (this.hike.stages[i].actionSets[j].actions[k].type === 'resource') {
                var resId = this.hike.stages[i].actionSets[j].actions[k].resource ? this.hike.stages[i].actionSets[j].actions[k].resource.id : null;
                this.hike.stages[i].actionSets[j].actions[k].resource = resId;
              }
            }
          }
        }
        this.loading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    addActionSet(idx) {
      var actionSetLength = this.hike.stages[idx].actionSets.length;
      var actionSet = _lodash.default.cloneDeep(this.emptyActionSet);
      this.hike.stages[idx].actionSets.push(actionSet);
      this.actionsetTab = `actionset${actionSetLength + 1}`;
    },
    canAddActionSet(stage) {
      /*
      if (stage.type === 'benchmark' || stage.type === 'summit'){
        if (stage.actionSets.length >=1)
          return false
        else return true
      }
      else {
        return true
      }
      */
      return true;
    },
    selectAction(e, stageIdx, actionSetIdx) {
      var action = null;
      var actionLength = this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.length;
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.splice(0, actionLength);
      if (e === 'benchmark' || e === 'summit') {
        // Only add first video
        action = _lodash.default.cloneDeep(this.emptyAction);
        action.scoreConfig = _lodash.default.cloneDeep(this.defaultScore);
        action.type = 'video';
        this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.push(action);
      } else {
        action = _lodash.default.cloneDeep(this.emptyAction);
        this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.push(action);
      }
    },
    canAddAction(actionSetType, actions) {
      if (actionSetType === 'bunny' || actionSetType === 'diamond' || actionSetType === 'moment' || actionSetType === 'info' || actionSetType === 'summitreport' || actionSetType === 'benchmarkreport') {
        // bunny / diamond / moment
        if (actions.length >= 1) {
          return false;
        } else {
          return true;
        }
      } else if (actionSetType === 'benchmark' || actionSetType === 'summit') {
        if (actions.length >= 9) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    addAction(stageIdx, actionSetIdx) {
      var action = _lodash.default.cloneDeep(this.emptyAction);
      action.scoreConfig = _lodash.default.cloneDeep(this.defaultScore);
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.push(action);
      // console.log('empty action', this.hike.stages[stageIdx].actionSets[actionSetIdx].actions)
    },
    addRecordingText(stageIdx, actionSetIdx, actionIdx) {
      var text = {
        interval: 1,
        text: ''
      };
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].recordingTexts.push(text);
    },
    checkScoreExist(action, actionSet) {
      var ret = false;
      if ((actionSet.type === 'benchmark' || actionSet.type === 'summit') && action.type === 'video') {
        ret = true;
        if (action.scoreConfig === undefined) {
          action.scoreConfig = _lodash.default.cloneDeep(this.defaultScore);
        }
      } else {
        ret = false;
      }
      // console.log(action)
      return ret;
    },
    removeActionSet(stageIdx, actionSetIdx) {
      this.hike.stages[stageIdx].actionSets.splice(actionSetIdx, 1);
      this.actionsetTab = actionSetIdx === 0 ? `actionset1` : `actionset${actionSetIdx}`;
    },
    removeAction(stageIdx, actionSetIdx, actionIdx) {
      this.hike.stages[stageIdx].actionSets[actionSetIdx].actions.splice(actionIdx, 1);
    },
    moveUp(stageIdx, actionSetIdx, actionIdx) {
      let actions = this.hike.stages[stageIdx].actionSets[actionSetIdx].actions;
      let currentAction = actions[actionIdx];
      this.$set(actions, actionIdx, actions[actionIdx - 1]);
      this.$set(actions, actionIdx - 1, currentAction);
    },
    moveDown(stageIdx, actionSetIdx, actionIdx) {
      let actions = this.hike.stages[stageIdx].actionSets[actionSetIdx].actions;
      let currentAction = actions[actionIdx];
      this.$set(actions, actionIdx, actions[actionIdx + 1]);
      this.$set(actions, actionIdx + 1, currentAction);
    },
    getActionSetVideoTotalLength(actionSet) {
      let totalMinSec = 0;
      let totalMaxSec = 0;
      let totalDt = 0;
      if (actionSet['actions'] !== undefined) {
        for (var i = 0; i < actionSet.actions.length; i++) {
          totalMaxSec += actionSet.actions[i].maxRecordingTime;
          totalMinSec += actionSet.actions[i].minRecordingTime;
          if (actionSet.actions[i].enableDialTest === true) {
            totalDt++;
          }
        }
      }
      return '[' + actionSet.actions.length + '] video. [' + totalDt + '] DialTest. [' + totalMinSec + 's] min recording time. [' + totalMaxSec + 's] Ideal recording time.';
    },
    getActionSetType(stageType) {
      var actionSetType = [];
      if (stageType === 'benchmark') {
        // actionSetType = ['benchmark', 'bunny', 'diamond', 'benchmarkreport']
        actionSetType = ['benchmark', 'bunny', 'diamond', 'moment', 'benchmarkreport', 'bonus'];
      } else if (stageType === 'summit') {
        // actionSetType = ['summit', 'bunny', 'diamond', 'info', 'summitreport']
        actionSetType = ['summit', 'moment', 'summitreport'];
      } else if (stageType === 'stage') {
        actionSetType = ['bunny', 'diamond', 'moment', 'info', 'bonus'];
        // for future use
        // actionSetType = ['bunny', 'diamond', 'moment',  'info', 'resource']
      } else {
        actionSetType = [];
      }
      return actionSetType;
    },
    getActionType(actionSetType, stageType) {
      console.log('At getActionType', actionSetType, stageType);
      var actionType = [];
      if (actionSetType === 'benchmark' || actionSetType === 'summit') {
        actionType = ['video'];
      } else if (actionSetType === 'moment') {
        // LHVO-4124 Benchmark or Summit stage only allow dial test exercise under moment
        if (stageType == 'benchmark' || stageType == 'summit') {
          actionType = ['dialtestexercise'];
        } else {
          actionType = ['video', 'resource', 'dialtestexercise'];
        }
      } else if (actionSetType === 'bunny' || actionSetType === 'diamond' || actionSetType === 'bonus') {
        actionType = ['video', 'info', 'skill', 'resource', 'game']; // Next time should add 'skill'
      } else if (actionSetType === 'benchmarkreport') {
        actionType = ['benchmarkreport'];
      } else if (actionSetType === 'summitreport') {
        actionType = ['summitreport'];
      } else if (actionSetType === 'info') {
        actionType = ['info'];
      } else if (actionSetType === 'resource') {
        actionType = ['resource'];
      } else if (actionSetType === 'skill') {
        actionType = ['skill'];
      } else if (actionSetType === 'game') {
        actionType = ['game'];
      } else {
        actionType = [];
      }
      return actionType;
    },
    calcSkillFactors(actionScoreSetting) {
      var total = 0;
      for (var i = 0; i < actionScoreSetting.length; i++) {
        if (typeof actionScoreSetting[i].rate !== 'undefined') {
          if (typeof actionScoreSetting[i].enable !== 'undefined' && actionScoreSetting[i].enable) {
            total += actionScoreSetting[i].rate;
          }
        }
      }
      return total.toFixed(2);
    },
    calcSkillCount(actionScoreSetting) {
      var total = 0;
      for (var i = 0; i < actionScoreSetting.length; i++) {
        if (typeof actionScoreSetting[i].rate !== 'undefined') {
          if (typeof actionScoreSetting[i].enable !== 'undefined' && actionScoreSetting[i].enable) {
            total++;
          }
        }
      }
      return total;
    },
    calcVideoScore(actionSet) {
      var total = 0;
      // console.log('showVideoScoreAlert', actionSet)
      if (typeof actionSet.actions !== 'undefined') {
        for (var i = 0; i < actionSet.actions.length; i++) {
          // console.log(`scor3e-${i}`, actionScoreConfig[i].scoreConfig)
          if (typeof actionSet.actions[i].scoreConfig !== 'undefined') {
            total += actionSet.actions[i].scoreConfig.rate;
          }
        }
      }
      return total;
    },
    calcVideoCount(actionSet) {
      if (typeof actionSet.actions !== 'undefined') {
        return actionSet.actions.length;
      }
      return 0;
    },
    async getHikeSkillList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      await (0, _hike.getSkillList)(token).then(response => {
        this.skillList = response.data.rows;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-skillList-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getHikeGameList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      await (0, _game.getGameForHike)(token).then(response => {
        this.gameList = response.data.rows;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-gameList-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    stageTabClick() {
      this.actionsetTab = 'actionset1';
    },
    openSkillDialog(actionIndex, asIndex, stageIndex) {
      this.dialogSkillVisible = true;
      this.stageIndex = stageIndex;
      this.asIndex = asIndex;
      this.actionIndex = actionIndex;
    },
    addSkillInAction(skillId, skillTitle) {
      this.hike.stages[this.stageIndex].actionSets[this.asIndex].actions[this.actionIndex].skill = skillId;
      this.dialogSkillVisible = false;
    },
    clearSkill(actionIndex, asIndex, stageIndex) {
      this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex].skill = undefined;
      // console.log('clear skill', this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex])
      // this.dialogSkillVisible = false
      this.$forceUpdate();
    },
    openGameDialog(actionIndex, asIndex, stageIndex) {
      this.dialogGameVisible = true;
      this.stageIndex = stageIndex;
      this.asIndex = asIndex;
      this.actionIndex = actionIndex;
    },
    clearGame(actionIndex, asIndex, stageIndex) {
      this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex].game = undefined;
      // console.log('clear skill', this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex])
      // this.dialogSkillVisible = false
      this.$forceUpdate();
    },
    addGameInAction(gameId, GameTitle) {
      this.hike.stages[this.stageIndex].actionSets[this.asIndex].actions[this.actionIndex].game = gameId;
      this.dialogGameVisible = false;
    },
    getResources() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _resource.fetchList)(token, this.resourceQuery).then(response => {
        const data = response.data;
        (0, _log.showDebugLog)('Resource-API-response', response.data);
        this.resourceOptions = data.rows;
        this.resourceTableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Resource-API-response', error);
        this.resourceTableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    openResourceDialog(actionIndex, asIndex, stageIndex) {
      this.dialogResourceVisible = true;
      this.stageIndex = stageIndex;
      this.asIndex = asIndex;
      this.actionIndex = actionIndex;
    },
    addResourceInAction(resId, resTitle) {
      this.hike.stages[this.stageIndex].actionSets[this.asIndex].actions[this.actionIndex].resource = resId;
      this.dialogResourceVisible = false;
    },
    clearResource(actionIndex, asIndex, stageIndex) {
      this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex].resource = undefined;
      // console.log('clear resource', this.hike.stages[stageIndex].actionSets[asIndex].actions[actionIndex])
      // this.dialogSkillVisible = false
      this.$forceUpdate();
    },
    checkArrayLength(obj) {
      if (Array.isArray(obj)) {
        return obj.length;
      } else {
        return 0;
      }
    },
    changeComponentType(event, actionIdx, actionSetIdx, stageIdx) {
      if (this.hike.stages && this.hike.stages[stageIdx].actionSets && this.hike.stages[stageIdx].actionSets[actionSetIdx].actions && this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx]) {
        const action = this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx];
        if (event !== 'video' && event !== 'resource') {
          action.isSubscriptionIndividualCoachingMandatoryActivity = false;
        }
        if (action.resource) {
          delete action.resource;
        }
      } else {
        console.log('object not exist');
      }
    },
    config720SurveyRateChange(s) {
      if (!s.enable720Survey) {
        this.survey720RateError = "";
        return;
      }
      const bossRate = s.config720Survey.bossRate ? s.config720Survey.bossRate : 0;
      const directRate = s.config720Survey.directRate ? s.config720Survey.directRate : 0;
      const peerRate = s.config720Survey.peerRate ? s.config720Survey.peerRate : 0;
      const raterRate = s.config720Survey.raterRate ? s.config720Survey.raterRate : 0;
      if (bossRate + directRate + peerRate + raterRate === 100) {
        this.survey720RateError = "";
      } else {
        this.survey720RateError = "Final Score: Total rate should be 100%";
      }
    },
    getSurvey720Status() {
      this.survey720Status = {};
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const stage = this.getCurrentStage();
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      if (stage !== undefined) {
        if (stage.type === "benchmark" || stage.type === "summit") {
          (0, _hike720Report.getSurvey720Result)(token, id, stage.id).then(response => {
            this.survey720Status = response.data;
          }).catch(error => {
            console.log(error);
          });
        }
      }
    },
    inputSurveyResult(type, stage) {
      this.survey720DataType = type;
      if (type === "peer") {
        this.survey720DialogType = "Peers";
      } else if (type === "boss") {
        this.survey720DialogType = "Boss";
      } else if (type === "directreport") {
        this.survey720DialogType = "Direct Report";
      }
      this.survey720TableTotalDataCount = 0;
      this.survey720TableData = {};
      this.survey720ScoreMapping = {};
      this.survey720TableHeader = [];
      this.survey720ParticipantWithoutSurveyList = [];
      this.survey720DialogVisible = true;
    },
    survey720EmailCheck(email) {
      let checkResult = "";
      let foundEmail = false;
      let uuid = "";
      for (const p of this.survey720ParticipantList) {
        if (email === _lodash.default.trim(p["email"]).toLowerCase()) {
          foundEmail = true;
          uuid = p["uuid"];
          break;
        }
      }
      if (!foundEmail) {
        checkResult = "SKIPPED: This person is not in the participant list";
      }
      return {
        result: checkResult,
        uuid: uuid
      };
    },
    survey720DataHandleSuccess({
      results,
      header
    }) {
      this.survey720TableHeader = header;
      this.survey720TableData = {};
      this.survey720ScoreMapping = {};
      this.survey720ParticipantWithoutSurveyList = [];
      this.survey720TableValidDataCount = 0;
      this.survey720TableTotalDataCount = results.length;
      for (const r of results) {
        let participantEmail = "";
        let scoreTotal = 0;
        let scoreCount = 0;
        for (const questionTitle of Object.keys(r)) {
          // Check if the question is number type.
          const theTitle = questionTitle.replace(/\u00a0/g, " ").toLowerCase();
          if (theTitle.includes("(select 1 to 10")) {
            scoreCount++;
            scoreTotal += parseFloat(_lodash.default.trim(r[questionTitle]));
          } else if (theTitle.includes("lifehikes id")) {
            participantEmail = _lodash.default.trim(r[questionTitle].toLowerCase());
          }
        }
        const checkResult = this.survey720EmailCheck(participantEmail);
        let avgScoreFloat = 0;
        if (scoreCount > 0) {
          avgScoreFloat = scoreTotal / scoreCount;
        }
        const participant = {
          email: participantEmail,
          uuid: checkResult["uuid"],
          checkResult: checkResult["result"]
        };
        if (checkResult["result"] === "") {
          this.survey720TableValidDataCount++;
        }
        if (Object.keys(this.survey720ScoreMapping).includes(participantEmail)) {
          this.survey720ScoreMapping[participantEmail] += avgScoreFloat;
        } else {
          this.survey720ScoreMapping[participantEmail] = avgScoreFloat;
        }
        if (Object.keys(this.survey720TableData).includes(participantEmail)) {
          this.survey720TableData[participantEmail]["reports"].push(r);
          this.survey720TableData[participantEmail]["averageScore"] = this.survey720ScoreMapping[participantEmail] / this.survey720TableData[participantEmail]["reports"].length;
        } else {
          this.survey720TableData[participantEmail] = {
            ...participant,
            reports: [r]
          };
          this.survey720TableData[participantEmail]["averageScore"] = this.survey720ScoreMapping[participantEmail];
        }
      }
      for (const p of this.survey720ParticipantList) {
        const email = p["email"];
        if (!Object.keys(this.survey720TableData).includes(email)) {
          this.survey720ParticipantWithoutSurveyList.push(p);
        }
      }
    },
    survey720DataBeforeUpload(file) {
      return true;
    },
    survey720DataUpload() {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const stage = this.getCurrentStage();
      if (stage !== undefined) {
        (0, _hike720Report.updateSurvey720Result)(token, id, stage.id, this.survey720DataType, this.survey720TableData).then(response => {
          this.loading = false;
          this.getSurvey720Status();
          (0, _log.displayPopupMessage)("Survey720 Excel updated", "success");
          this.survey720DialogVisible = false;
        }).catch(error => {
          this.loading = false;
          (0, _log.showDebugLog)("Hike-updateSurvey720Result-API-error", error);
          (0, _log.displayPopupMessage)(error, "error");
        });
      } else {
        (0, _log.showDebugLog)("Hike-updateSurvey720Result-stage-empty-error", "Please save Hike stage content before upload the Excel");
        (0, _log.displayPopupMessage)("Please save Hike stage content before upload the Excel", "error");
      }
    },
    getHikeParticipants() {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      (0, _hike.getParticipant)(token, id).then(response => {
        this.loading = false;
        this.survey720ParticipantList = response.data.rows;
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)("Hike-getParticipant-API-error", error);
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    getSurvey720Status() {
      this.survey720Status = {};
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const stage = this.getCurrentStage();
      if (stage !== undefined) {
        if (stage.type === "benchmark" || stage.type === "summit") {
          (0, _hike720Report.getSurvey720Result)(token, id, stage.id).then(response => {
            this.survey720Status = response.data;
          }).catch(error => {
            console.log(error);
          });
        }
      }
    },
    getCurrentStage() {
      const stageIdx = parseInt(this.firstTab.replace("stage", "")) - 1;
      if (stageIdx < this.hike.stages.length) {
        const stage = this.hike.stages[stageIdx];
        return stage;
      }
      return undefined;
    },
    skillShowNewKey(key) {
      let skill = this.scLibrary.find(p => p.key === key);
      if (skill) {
        return skill.newKey ? skill.newKey : skill.key;
      } else {
        return key;
      }
    },
    p2pDialTestChange(enableP2pDialTest, stageIdx, actionSetIdx, actionIdx) {
      //console.info(enableP2pDialTest)
      if (enableP2pDialTest) {
        this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].p2pDialTestRaterMin = 1;
        this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].p2pDialTestRaterMax = 5;
      } else {
        this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].p2pDialTestRaterMin = null;
        this.hike.stages[stageIdx].actionSets[actionSetIdx].actions[actionIdx].p2pDialTestRaterMax = null;
      }
    },
    getRelatedLoops() {
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (!id || !token) return;
      this.relatedLoopsLoading = true;
      (0, _hike.hikeRelatedLoops)(token, id).then(response => {
        this.relatedLoops = response && response.data && response.data.rows ? response.data.rows : [];
      }).catch(error => {
        (0, _log.showDebugLog)('hike-hikeRelatedLoops-error', error);
        this.relatedLoops = [];
      }).finally(() => {
        this.relatedLoopsLoading = false;
      });
    }
  }
};